import { FreightInfoModel } from '@/types/B2BcontentServerContract';
import { ref, Ref } from 'vue';
import utilities from '@/shared/utilities.service';
import { ProductClientService } from '@/types/productServerApi';
import siteContextService from '@/b2c/shared/site-context.service';

const freightInfo: Ref<FreightInfoModel | null> = ref(null);
const hasFreightInfo = ref<{ [key: string]: boolean; }[] | {}>({});
const isOpen = ref<boolean>(false);

export default function useFreightInformation() {
    const setProductFreightInfo = () => {
        freightInfo.value = siteContextService.freightInfo;
    };

    const fetchHasFreightInformation = async(variantIdList: string[]) => {
        const productWithCachedFreightInfoState = Object.keys(hasFreightInfo.value);
        const productWithoutCachedFreightInfoState = variantIdList.filter((itemId) => productWithCachedFreightInfoState.indexOf(itemId) === -1);
        if (productWithoutCachedFreightInfoState.length > 0) {
            const response = await ProductClientService.getFreightInformation(productWithoutCachedFreightInfoState).then(utilities.unwrapModel);
            hasFreightInfo.value = Object.assign(hasFreightInfo.value, response);
        }
    };

    const getHasFreightInfo = (variantId: string): boolean => {
        if (hasFreightInfo.value && hasFreightInfo.value[variantId]) {
            return hasFreightInfo.value[variantId];
        }
        return false;
    };

    const toggleFreightInfo = (): void => {
        isOpen.value = !isOpen.value;
    };

    return {
        fetchHasFreightInformation,
        getHasFreightInfo,
        setProductFreightInfo,
        toggleFreightInfo,
        isOpen,
        freightInfo,
    };
}
